import { FC } from 'react';
import { Grid, GridItem } from '@chakra-ui/react';

import Callout, { CalloutProps } from 'components/_core/Callout';
import IconButton from 'components/_core/IconButton';
import IconCircle from 'components/_core/IconCircle';
import { FilePickerErrorCode } from 'components/FilePicker/types';

import { MAX_LOGO_SIZE } from '../PickerStep/constants';
import locales from './locales';

type ErrorCode = FilePickerErrorCode | 'connectionError';

const getErrorMessage = (errorCode: ErrorCode, fileName?: string | null) => {
  let title;
  let description;

  switch (errorCode) {
    case 'connectionError':
      description = locales.connectionError.description;
      title = locales.connectionError.title;
      break;
    case 'fileTooBig':
      title = fileName;
      description = locales.formatString(locales.maxSize, {
        maxSize: MAX_LOGO_SIZE,
      });
      break;
    case 'unsupportedFileType':
      title = fileName;
      description = locales.fileType;
  }

  return { description, title };
};

interface UploadErrorCalloutProps extends CalloutProps {
  errorCode: ErrorCode;
  fileName?: string | null;
  onExtraAction?: () => void;
}

const UploadErrorCallout: FC<UploadErrorCalloutProps> = ({
  errorCode,
  fileName,
  onExtraAction,
  ...props
}) => {
  const { description, title } = getErrorMessage(errorCode, fileName);
  const showIcon = errorCode !== 'connectionError';

  return (
    <Callout hideIcon variant="error" {...props}>
      <Grid
        alignItems="center"
        columnGap="space-16"
        templateColumns="max-content 1fr max-content"
        width="full"
      >
        {showIcon ? (
          <IconCircle
            backgroundColor="red.300"
            color="red.700"
            name="picture"
            size="40px"
          />
        ) : null}

        <GridItem>
          {title ? <Callout.Title>{title}</Callout.Title> : null}
          {description ? (
            <Callout.Content>{description}</Callout.Content>
          ) : null}
        </GridItem>

        {onExtraAction ? (
          <IconButton
            aria-label={locales.closeButtonAriaLabel}
            icon="cross"
            iconSize="icon-24"
            onClick={onExtraAction}
            variant="inline-secondary"
          />
        ) : null}
      </Grid>
    </Callout>
  );
};

export default UploadErrorCallout;
